import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { Link } from "react-router-dom";
import DownloadField from "../unit/DownloadField";
import FileIconByExtension from "../unit/FileIconByExtension";
import formatDate from "./formatDate";
import useNotify from "./useNotify";
import {
  clearStoredAuthState,
  ensureFreshToken,
  getSecondsUntilTokenExpiry,
  refreshToken,
} from "../authProvider";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const DocDeleteIcon = ({ ...props }) => {
  const { docId, docType, appId } = props;
  const reqUrl = "files/download/" + appId + "/" + docType + "";
  const { success, warning, error, info } = useNotify();

  const handDelete = (docId: number, reqUrl: string) => {
    error("developing");
  };

  return (
    <Link to="" onClick={() => handDelete(docId, reqUrl)}>
      <DeleteIcon color="error" />
    </Link>
  );
};
const DocumentActionIcon = ({ ...props }) => {
  const { docId, docType, docFileName, appId } = props;
  return (
    <>
      <DownloadField
        docId={docId}
        docType={docType}
        docFileName={docFileName}
        appId={appId}
      />

      {docType == "bbupload" ? (
        <IconButton edge="end" aria-label="">
          <DocDeleteIcon docId={docId} docType={docType} appId={appId} />
        </IconButton>
      ) : (
        <> </>
      )}
    </>
  );
};
const UploadFile = ({ ...props }) => {
  // const {appId,uploadType, uploadName} = props;
  const appId = props.appId;
  if (!appId) {
    return <div>Application ID is required</div>;
  }
  let uploadType = "bb_upload_applications";
  let uploadStep = "initiate Review";
  if (props.uploadType) {
    uploadType = props.uploadType;
  }
  if (props.uploadStep) {
    uploadStep = props.uploadStep;
  }

  interface Item {
    id: string;
    name: string;
    filetype?: string;
  }

  const [items, setItems] = React.useState<Item[]>([]);
  const [uploadBtnStatus, setUploadBtnStatus] = React.useState(false);
  const [uploadingStatus, setUploadingStatus] = React.useState("");
  const { successNotify, errorNotify, infoNotify } = useNotify();

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    let uploadFileName = document.getElementById(
      "uploadFileName"
    ) as HTMLInputElement;
    let file = e.target.files?.[0];
    if (!file) {
      return false;
    }
    let fileAize = file.size / 1024;
    if (fileAize > 1024) {
      errorNotify("File size should be less than 1MB");
      return false;
    }
    let fileNameType = file.name.split(".").pop()?.toLowerCase() || "";
    let fileType = ["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx"];
    if (fileType.indexOf(fileNameType) == -1) {
      errorNotify(
        "File type should be pdf, jpg, jpeg, png, doc, docx, xls, xlsx"
      );
      return false;
    }
    let fileName = file.name;
    //if uploadFileName have value, will use uploadFileName as file name
    if (uploadFileName) {
      fileName = uploadFileName.value
        ? uploadFileName.value + "." + fileNameType
        : fileName;
    } else {
      errorNotify("Please enter new file name");
      return false;
    }
    if (file) {
      setUploadBtnStatus(true);
      setUploadingStatus("Uploading...");
      await ensureFreshToken();

      const reqUrl = `files`;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("uploadType", uploadType);
      formData.append("uploadStep", uploadStep);
      formData.append("uploadFileName", fileName);
      //echo formData data
      const formJson = Object.fromEntries((formData as any).entries());

      //console.log("formData fileName===>",formJson.fileName);
      //console.log("formData file===>",formJson.file);
      // options.headers.set("reqDivision", localStorage.getItem("division"));
      // options.headers.set("reqBank", localStorage.getItem("bank"));
      // // options.headers.set("reqBank", "");
      // options.headers.set("reqAdmin", localStorage.getItem("permissions"));
      const csrfToken = localStorage.getItem("csrfToken");
      // //    console.log("access_token==>",access_token);
      // //    console.log("csrfToken==>",csrfToken);
      // options.headers.set("Authorization", `Bearer ${access_token}`);
      // options.headers.set("X-CSRF-TOKEN", `${csrfToken}`);
      // options.headers.set("X-XSRF-TOKEN", `${csrfToken}`);
      //   options.headers.set("reqType", ""); // '' or accont

      const executeUpload = async () => {
        const currentAccessToken = localStorage.getItem("access_token");
        return await fetch(
          `${import.meta.env.VITE_API_URL}/files/upload/` + appId,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${currentAccessToken}`,
              "X-CSRF-TOKEN": `${csrfToken}`,
              "X-XSRF-TOKEN": `${csrfToken}`,
              reqDivision: localStorage.getItem("division") || "",
              reqBank: localStorage.getItem("bank") || "",
              reqAdmin: localStorage.getItem("permissions") || "",
              reqType: "",
            },
            body: formData,
          }
        );
      };

      executeUpload()
        .then(async (response) => {
          if (response.status === 401 && getSecondsUntilTokenExpiry() <= 0) {
            await refreshToken();
            return await executeUpload();
          }

          if (response.status === 401) {
            clearStoredAuthState();
            window.location.href = "/login";
            throw new Error("Unauthenticated");
          }

          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          if (props?.refreshDocumentList) {
            props.refreshDocumentList();
          } else {
            let fileId = data.fileId;
            let fileName = data.fileName;
            let newItem = {
              id: fileId,
              name: fileName,
              filetype: fileNameType,
            };
            setItems([...items, newItem]);
          }

          setUploadBtnStatus(false);
          setUploadingStatus("");
          uploadFileName.value = "";
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const CustomRemoveCircle = ({ ...props }) => {
    const { appId, fileId, fileName } = props;

    const handleRemove = (appId: string, fileId: string) => {
      //remove file api
      const formData = new FormData();
      formData.append("fileId", fileId);
      formData.append("fileName", fileName);

      fetch(`${import.meta.env.VITE_API_URL}/files/remove/` + appId, {
        method: "POST",
        headers: {},
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          successNotify("File removed successfully");
        })
        .catch((error) => {
          console.error(error);
        });

      //remove file UI
      if (items) {
        let newitems = items.filter((item) => item.id !== fileId);
        setItems(newitems);
      }
    };

    return (
      <IconButton
        aria-label="delete"
        onClick={() => handleRemove(appId, fileId)}
      >
        <DeleteIcon />
      </IconButton>
    );
  };

  const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setUploadBtnStatus(true);
    } else {
      setUploadBtnStatus(false);
    }
  };

  return (
    <>
      {/* <Typography variant="h6">
        {items.map((item) => (
          <div key={item.id}>
            {item.name}{" "}
            <CustomRemoveCircle
              appId={appId}
              fileId={item.id}
              fileName={item.name}
            />
          </div>
        ))}
      </Typography> */}
      <List
        sx={{
          width: "100%",
          paddingTop: 0,
          maxWidth: 360,
          bgcolor: "background.paper",
        }}
      >
        {items.map((item, index) => (
          <ListItem
            key={index}
            // secondaryAction={
            //   <DocumentActionIcon
            //     docId={item.id}
            //     docType={item.filetype}
            //     docFileName={item.name}
            //     appId={appId}
            //   />
            // }
          >
            {/* <ListItemAvatar>
              <Avatar>
                <FileIconByExtension filename={item.name} />
              </Avatar>
            </ListItemAvatar> */}
            <ListItemAvatar>
              {/* <FileIconByExtension filename={item.name} /> */}
              <DocumentActionIcon
                docId={item.id}
                docType={item?.filetype}
                docFileName={item.name}
                appId={appId}
                key={
                  "document_action_icon_" +
                  Math.random().toString(36).substring(2, 15)
                }
              />
            </ListItemAvatar>
            {/* secondary use today date */}
            <ListItemText
              sx={{
                "& .MuiListItemText-primary": {
                  color: "black",
                  // fontSize: "0.875rem",
                  fontSize: "1rem",
                },
                "& .MuiListItemText-secondary": {
                  fontSize: "0.75rem",
                  color: "gray",
                },
                "& .MuiTypography-body1": { color: "black" },
                "& .MuiTypography-body2": { color: "black" },
              }}
              primary={item.name}
              // secondary={formatDate("today")}
              // secondary={"Institutional User " + formatDate("today")}
              secondary={
                formatDate("today") + " by " + localStorage.getItem("username")
              }
            />
          </ListItem>
        ))}
      </List>
      {/* hidden filed, set item.id string use , implode */}
      <input
        type="hidden"
        name="uploadFileId"
        value={items.map((item) => item.id).join(",")}
      />
      {/* add file name filed */}
      <TextField
        id="uploadFileName"
        label="Enter New File Name"
        variant="outlined"
        onChange={handleFileNameChange}
      />
      <Button
        component="label"
        role={undefined}
        variant="contained"
        disabled={!uploadBtnStatus}
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
        sx={{ width: "100%", maxWidth: "500px", mt: 1 }}
      >
        <VisuallyHiddenInput
          type="file"
          id="uploadfile"
          name="uploadfile"
          onChange={handleFileChange}
        />{" "}
        Upload new file
        {uploadingStatus}
      </Button>
    </>
  );
};

export default UploadFile;
